import { Line } from '../Line';
import { ArrowHolder } from './ArrowHolder';
import { IObject3D } from '../../Interfaces';
import { PolyLine } from '../PolyLine';
import { ConnectionPoint } from '..';

declare const THREE: any;

export class TextArrow extends (THREE.Object3D as { new(): IObject3D; }) {

  private startPoint;
  private endPoint;
  private color;

  static readonly Name = 'TextArrow';

  constructor(startPoint) {
    super();
    this.startPoint = startPoint;
    this.color = new THREE.Color(0x000000);
    this.name = TextArrow.Name;

    this.add(new Line);

    // this.getObjectByName<PolyLine>(PolyLine.Name).add(new Line());


    const endPoint = new THREE.Vector3(50, 0, 50).add(startPoint);
    this.endPoint = endPoint;

    const connectionPoint1 = new ConnectionPoint(undefined, this.getObjectByName<Line>(Line.Name).id);
    connectionPoint1.position.copy(startPoint);
    const connectionPoint2 = new ConnectionPoint(this.getObjectByName<Line>(Line.Name).id, undefined);
    connectionPoint2.position.copy(endPoint);
    this.add(connectionPoint1);
    this.add(connectionPoint2);
    this.getObjectByName<Line>(Line.Name).update(startPoint, endPoint);

    // this.getObjectByName<Line>(Line.Name).visible = visible;
    this.add(new ArrowHolder());
    this.getObjectByName<ArrowHolder>(ArrowHolder.Name).update(startPoint, endPoint);
    // this.getObjectByName<ArrowHolder>(ArrowHolder.Name).visible = visible;
  }


  changePointsVisibility(visible: boolean) {
    this.children
      .filter(ch => ch instanceof ConnectionPoint)
      .forEach(p => p.visible = visible);
  }

  update(startPoint, endPoint?) {
    endPoint = endPoint ? endPoint : this.endPoint;
    this.startPoint.copy(startPoint);
    this.endPoint.copy(endPoint);
    this.children
      .filter(ch => ch instanceof ConnectionPoint)
      .forEach(p => {
        if (p.userData.prevLineId) {
          p.position.copy(endPoint);
        } else {
          p.position.copy(startPoint);
        }
      });
    this.getObjectByName<Line>(Line.Name).update(startPoint, endPoint);
    this.getObjectByName<Line>(Line.Name).position.set(startPoint.x, startPoint.y, startPoint.z);
    this.getObjectByName<ArrowHolder>(ArrowHolder.Name).update(startPoint, endPoint);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Text/TextArrow.ts